import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "mode",
    "generatedFields",
    "manualFields",
    "password",
    "confirmation",
    "submit"
  ]

  connect() {
    this.toggleMode()
  }

  toggleMode() {
    const manualMode = this.modeTargets.some((input) => input.checked && input.value === "manual")

    this.generatedFieldsTarget.classList.toggle("d-none", manualMode)
    this.manualFieldsTarget.classList.toggle("d-none", !manualMode)

    this.passwordTarget.disabled = !manualMode
    this.passwordTarget.required = manualMode
    this.confirmationTarget.disabled = !manualMode
    this.confirmationTarget.required = manualMode
    this.submitTarget.textContent = manualMode ? "Redefinir senha" : "Gerar e redefinir"
  }

  submit() {
    this.submitTarget.disabled = true
    this.submitTarget.innerHTML = '<span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>Salvando'
  }
}
